import React
    from "react";
import styled
    from "styled-components";
import {
    SnackbarProvider,
    useSnackbar
} from "notistack";
import HeroIcon
    from "@components/ui/icons/HeroIcon";
import {XMarkIcon} from "@heroicons/react/24/outline";

const StyledSnackbarProvider = styled(SnackbarProvider)`
  &.SnackbarContent-root.SnackbarItem-contentRoot {
    background-color: white;
    color: currentColor;
    font-size: 13px;

    &.SnackbarItem-variantSuccess {
      .MuiSvgIcon-root {
        color: #4caf50;
      }

      .SnackbarItem-action {
        .MuiSvgIcon-root {
          color: black;
        }
      }
    }


    &.SnackbarItem-variantError {
      .MuiSvgIcon-root {
        color: #f44336;
      }
    }

    &.SnackbarItem-variantInfo {
      .MuiSvgIcon-root {
        color: #2196f3;
      }
    }

    &.SnackbarItem-variantWarning {
      .MuiSvgIcon-root {
        color: #ff9800;
      }
    }
  }

  .SnackbarItem-message {
    flex-grow: 1;
    align-items: start;
  }
`

const CloseNotificationButton = (snackbarId) => {
    const {closeSnackbar} = useSnackbar();

    return (
        <button className='border-0 bg-transparent pt-2' onClick={() => closeSnackbar(snackbarId)}>
            <HeroIcon componentName={XMarkIcon} />
        </button>
    )
}

const NotificationContext = ({
                                 children,
                             }) => {
    return (
        <StyledSnackbarProvider
            maxSnack={3}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right'
            }}
            action={CloseNotificationButton}>
            {children}
        </StyledSnackbarProvider>
    )
}

export default NotificationContext;